"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    "& div:not(.open) span.hidden": {
      display: "none"
    },
    "& ul": {
      margin: theme.spacing(2, 0)
    }
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "center",
    position: "relative",
    textAlign: "center",
    "&::before": {
      background: theme.palette.divider,
      content: "''",
      height: 1,
      left: 0,
      marginTop: -2,
      position: "absolute",
      right: 0,
      top: "50%",
      zIndex: theme.zIndex.overlay
    },
    "&::after": {
      background: "linear-gradient(to bottom, ".concat(theme.palette.text.gradient.from, ", ").concat(theme.palette.text.gradient.to, ")"),
      content: "''",
      height: 32,
      left: 0,
      marginTop: -1,
      position: "absolute",
      right: 0,
      top: -25,
      zIndex: theme.zIndex.default
    }
  },
  button: {
    background: theme.palette.common.white,
    display: "inline-block",
    padding: theme.spacing(0, 1),
    textAlign: "center",
    zIndex: theme.zIndex.overlay
  },
  buttonLabel: {
    fontWeight: 700
  }
}));
const Text = props => {
  const {
    text
  } = props.data;
  const css = useStyles();
  const [open, setOpen] = (0, _react.useState)(false);
  const toggleClass = () => {
    setOpen(!open);
  };
  if (!text) {
    return null;
  }
  let button;
  if (!open && text.indexOf("<span class=\"hidden\">") > -1) {
    button = /*#__PURE__*/_react.default.createElement("div", {
      className: css.buttonWrapper
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: css.button,
      onClick: toggleClass,
      color: "primary"
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: css.buttonLabel,
      variant: "body2"
    }, "Mehr anzeigen")));
  }
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.root,
    component: "div"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: open ? "open" : null,
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), button));
};
var _default = exports.default = Text;